module.exports = __webpack_public_path__ + "static/village_card_img10@2x-6e54fb2ad1210bbc87b16cd2d9601ead.png";